// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a1762fadfcbd485b2a77","655":"b31947cdd22c2efd3b2c"}[chunkId] + ".js";
};